module.exports = __webpack_public_path__ + "static/media/upload.70147e83.svg";